
import Chip from '@mui/joy/Chip';

import RoleStack from 'components/RoleStack';
import { DurationSeconds } from './Date';
import { Tooltip } from '@mui/joy';

import { clock_duration_color } from 'utils/misc';

export default function ClockTotalChip({ total_seconds }: { total_seconds: number }) {
    if (!total_seconds) return null;
    const color = clock_duration_color(total_seconds);

    return (

        <RoleStack role="assistant" spacing={1} direction="row" alignItems="center" justifyContent="center">
            <Tooltip arrow title="Amount of time clocked in">
                <Chip variant="outlined" size="sm" color={color}>
                    <DurationSeconds seconds={total_seconds} />
                </Chip>
            </Tooltip>
        </RoleStack>
    );
}
